import { useState } from "react";
import { useTheme, Box, Typography, Tooltip } from "@mui/material";
import { HelpRounded } from "@mui/icons-material";
import SwitchableBlock from "./SwitchableBlock";
import { PasswordField } from "../../general";
import { generateRandomPasscode } from "../../../utils";

const Locking = ({
  advanced,
  setAdvancedSafe,
  additional,
  setAdditionalSafe,
}) => {
  const theme = useTheme();

  const { locking } = additional;

  return (
    <SwitchableBlock
      switcher={locking}
      handleSwitch={(e) => {
        setAdvancedSafe({ passcode: e.target.checked ? "" : null });
        setAdditionalSafe({ locking: e.target.checked });
      }}
      label={
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography valiant="h1" component="div" sx={{ fontWeight: "bold" }}>
            Enable passcode protection
          </Typography>
          <Box>
            <Tooltip
              title="Redirect will be allowed only if the correct passcode is entered"
              placement="right"
              arrow
            >
              <HelpRounded
                fontSize="small"
                sx={{ color: theme.palette.mode === "light" && "#757575" }}
              />
            </Tooltip>
          </Box>
        </Box>
      }
      field={
        <CustomLockingModeExpanded
          advanced={advanced}
          setAdvancedSafe={setAdvancedSafe}
        />
      }
    />
  );
};

const CustomLockingModeExpanded = ({ advanced, setAdvancedSafe }) => {
  const [showPasscode, setShowPasscode] = useState(false);
  const handleClickShowPasscode = () => setShowPasscode((show) => !show);

  const generatePasscode = () =>
    setAdvancedSafe({ passcode: generateRandomPasscode() });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 0.5 }}>
      <Box sx={{ display: "flex", alignItems: "flex-end", gap: 2 }}>
        <PasswordField
          label="Passcode"
          value={advanced.passcode}
          handleChange={(e) => setAdvancedSafe({ passcode: e.target.value })}
          show={showPasscode}
          handleShow={handleClickShowPasscode}
          style={{ width: { xs: "100%", md: "30vw" } }}
          variant="standard"
          generateFunc={generatePasscode}
        />
      </Box>
      <Typography component="div" sx={{ fontSize: "12px" }}>
        Passcode must be at least 5 characters long.
      </Typography>
    </Box>
  );
};

export default Locking;
